import * as debug from './debug.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISearchResponseBase } from '../responses/isearch-response-base';
import { toHttpParams } from '../utils/utility.common';
import { take } from 'rxjs/operators';

/** Provides reusable methods for commonly used http calls. */
@Injectable({ providedIn: 'root' })
export class HttpService {
	constructor(protected readonly httpClient: HttpClient) {
		debug.log('003 HttpService instantiated');
	}

	/** Similar to get method but explicitly transform query parameter into: { search: query } */
	getSuggestions<TResponse>(url: string, query: string) {
		const param = { search: query };
		return this.get<TResponse>(url, param);
	}

	/** Similar to get method but explicitly returns ISearchResponseBase type. */
	search<TRequest, TResponse>(url: string, request: TRequest) {
		return this.get<ISearchResponseBase<TResponse>>(url, request);
	}

	/** Calls http GET. Calls take(1) to auto unsubscribe. */
	get<TResponse>(url: string, params?: any): Observable<TResponse> {
		const httpParams = toHttpParams(params);
		const config = { params: httpParams };
		return this.httpClient.get<TResponse>(url, config).pipe(
			take(1) // auto unsubscribe
		);
	}

	/** Calls http POST */
	post<TResponse>(url: string, body?: any): Observable<TResponse> {
		return this.httpClient.post<TResponse>(url, body);
	}

	/** Calls http PUT */
	update(url: string, body?: any, options?: any): Observable<ArrayBuffer> {
		return this.httpClient.put(url, body, options);
	}

	/** Calls http DELETE */
	delete(url: string, options?: any): Observable<ArrayBuffer> {
		return this.httpClient.delete(url, options);
	}
}
